import { createContext, useContext } from 'react'
import type { ApiKeysClient } from './apiKeys.types'

export const ApiKeysClientContext = createContext<ApiKeysClient | null>(null)

export function useApiKeysClient(): ApiKeysClient {
  const client = useContext(ApiKeysClientContext)
  if (!client) {
    throw new Error('useApiKeysClient must be used inside <ApiKeysClientProvider>')
  }
  return client
}

/** True when the workspace should talk to the in-memory client. */
export function isMockApiKeysEnabled(env: ImportMetaEnv = import.meta.env): boolean {
  return env.VITE_DEVELOPER_PLATFORM_MOCK_API === 'true'
}
